import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, TextField, Button, Typography, CircularProgress, InputAdornment } from "@mui/material";
import { styled } from "@mui/system";
import {
  FaUserAlt,
  FaEnvelope,
  FaBuilding,
  FaPhone,
  FaMap,
} from "react-icons/fa";
import BASE_API_URL from "../apis/index";
import axios from "axios";

const ContactUsPage = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    email: "",
    company: "",
    phone: "",
    address: "",
    message: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await axios.post(`${BASE_API_URL}/api/user/contact`, form);

      if (response.data.status !== "ok") {
        throw new Error(response.data.message || "Submission failed");
      }

      navigate("/login");
    } catch (err) {
      setError(err.response?.data?.message || err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Wrapper>
      <Typography variant="h4">Connect With Us</Typography>
      <Typography variant="body1">
        We’re here to help you make the most of our platform. If you are a new
        user looking to register your company, or an approved member ready to
        add your products or services under your company profile, our team is
        here to guide you through every step.
      </Typography>

      <Box component="form" onSubmit={handleSubmit} noValidate>
        <Box className="form-group">
          <TextField
            name="name"
            label="Name"
            placeholder="Enter your name"
            value={form.name}
            onChange={handleChange}
            required
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <FaUserAlt style={{ color: "#1976d2" }} />
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <Box className="form-group">
          <TextField
            name="email"
            label="Email"
            type="email"
            placeholder="Enter your email"
            value={form.email}
            onChange={handleChange}
            required
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <FaEnvelope style={{ color: "#1976d2" }} />
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <Box className="form-group">
          <TextField
            name="company"
            label="Company"
            placeholder="Enter your company"
            value={form.company}
            onChange={handleChange}
            required
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <FaBuilding style={{ color: "#1976d2" }} />
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <Box className="form-group">
          <TextField
            name="phone"
            label="Phone Number"
            placeholder="Enter your phone number"
            value={form.phone}
            onChange={handleChange}
            required
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <FaPhone style={{ color: "#1976d2" }} />
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <Box className="form-group">
          <TextField
            name="address"
            label="Address"
            placeholder="Enter your address"
            value={form.address}
            onChange={handleChange}
            required
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <FaMap style={{ color: "#1976d2" }} />
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <Box className="form-group">
          <TextField
            name="message"
            label="Message"
            placeholder="Your message"
            value={form.message}
            onChange={handleChange}
            required
            fullWidth
            multiline
            rows={4}
          // InputProps={{
          //   startAdornment: (
          //     <InputAdornment position="start">
          //       <FaMap style={{ color: "#1976d2" }} />
          //     </InputAdornment>
          //   ),
          // }}
          />
        </Box>

        {error && <Typography className="errorText">{error}</Typography>}

        <Button
          type="submit"
          fullWidth
          variant="contained"
          className="submitButton"
          disabled={loading}
          size="large"
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : "Send"}
        </Button>
      </Box>
    </Wrapper>
  );
};

export default ContactUsPage;

const Wrapper = styled(Box)(({ theme }) => ({
  maxWidth: "750px",
  minHeight: "65vh",
  margin: "100px auto",
  borderRadius: "10px",
  padding: "20px",
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  "& h4": {
    textAlign: "center",
    color: "brown",
    marginBottom: "0px",
  },
  "& p": {
    textAlign: "center",
    marginBottom: "20px",
  },
  "& .form-group": {
    marginBottom: "16px",
  },
  "& .submitButton": {
    background: `linear-gradient(155deg, brown 0%, orange 100%)`,
    color: "#fff",
    "&:hover": {
      background: `linear-gradient(225deg, brown 0%, orange 100%)`,
    },
  },
  "& .errorText": {
    color: "red",
    textAlign: "center",
  },
}));
